import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import {User} from "@commons/models/domain/User";

import {NewNavigationService} from "@shared/services/new-navigation.service";
import {UserHttpService} from "@shared/services-http/user-http.service";
import { LanguageService } from '@shared/services/language.service';
import { HELP_LINK } from '@src/app/utils/help-links';

@Component({
  selector: 'app-profile-data',
  templateUrl: './profile-data.component.html',
  styleUrls: ['./profile-data.component.scss']
})
export class ProfileDataComponent implements OnInit {

  @Input() isPasswordChanged = false;
  @Output() onPasswordChange = new EventEmitter();
  @Output() onRedirectToAccountData = new EventEmitter();

  isVisible = false;

  public menuList: {title: string, img: string, height: string, colorText?: string, onClick: () => void}[] = [
    {title: this.translate.instant('yourProfile.accountData'), img: '/assets/img/user-circle-gear.svg', height: '20px', onClick: () => this.onRedirectToAccountData.emit() },
    {title: this.translate.instant('yourProfile.changePassword'), img: '/assets/img/password.svg', height: '15px', onClick: () => this.onNavigateToPasswordChange() },
    {title: this.translate.instant('yourProfile.knowledgebase'), img: '/assets/img/helpicon.svg', height: '18px', onClick: () => this.help() },
    {title: this.translate.instant('yourProfile.logout'), img: '/assets/img/logout.svg', height: '18px', colorText: '#FF0032', onClick: () => this.logout() }
  ];

  get user(): User | undefined {
    return this.userHttpService?.userViewModel?.user;
  }

  get userInitials(): string {
    return this.userHttpService?.userViewModel?.initials ?? '';
  }

  constructor(
    private newNavigationService: NewNavigationService,
    private userHttpService: UserHttpService,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
  }

  private onNavigateToPasswordChange(): void {
    this.onPasswordChange.emit();
  }

  private logout(): void {
    this.newNavigationService.toLogout();
  }

  private help(): void {
    window.open(HELP_LINK[this.languageService.current], '_blank');
  }

}
